import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    emoji: '🌅',
    name: 'Bonus 1 — Routine di Apertura',
    desc: 'Aprire ogni lezione con presenza e calma.'
  }, {
    emoji: '💭',
    name: 'Bonus 2 — 21 Intuizioni Profonde',
    desc: 'Frasi e riflessioni da condividere in aula.'
  }, {
    emoji: '🔗',
    name: 'Bonus 3 — Manuale Transizioni Fluide',
    desc: 'Collegare le posizioni senza intoppi.'
  }, {
    emoji: '🎙️',
    name: "Bonus 4 — L'Arte della Voce",
    desc: 'Guidare con una voce che ispira fiducia.'
  }, {
    emoji: '🧘‍♀️',
    name: 'Bonus 5 — 20 Sequenze Illustrate',
    desc: "Pronte da seguire a colpo d'occhio."
  }, {
    emoji: '✨',
    name: 'Bonus 6 — Il Fattore Chiusura',
    desc: 'Chiudere ogni lezione lasciando il segno.'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-25">
            🎁 6 Bonus Esclusivi
          </h2>
          <p className="text-brand-gray" data-id="element-26">
            Valore totale di{' '}
            <span className="font-bold text-brand-terracotta line-through" data-id="element-27">
              € 96
            </span>{' '}
            — Inclusi <strong className="text-brand-text" data-id="element-28">GRATIS</strong>
          </p>
        </div>

        <div className="space-y-4" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl p-4 md:p-6 flex items-center gap-4 md:gap-6 shadow-sm border border-brand-creamDark/50" data-id="element-30">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold shrink-0 text-sm md:text-base" data-id="element-31">
                {i + 1}
              </div>
              <div className="w-12 h-12 md:w-16 md:h-16 bg-brand-creamDark rounded-lg shrink-0 flex items-center justify-center text-2xl" data-id="element-32">
                {bonus.emoji}
              </div>
              <div className="flex-1" data-id="element-33">
                <h3 className="font-bold text-brand-text text-sm md:text-base mb-1" data-id="element-34">
                  {bonus.name}
                </h3>
                <p className="text-brand-gray text-xs md:text-sm mb-1" data-id="element-35">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-36">
                  <span className="text-brand-terracotta line-through font-medium" data-id="element-37">
                    € 16
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-38">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}